import fixPublicPath from '../lib/fix-public-path'
import { requestIdleCallbackShim } from '../lib/request-idle-callback'

declare var __IS_LEGACY__
if (__IS_LEGACY__) {
  require('core-js')
  require('whatwg-fetch')
  require('@webcomponents/custom-elements')

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined }
    var evt = document.createEvent('CustomEvent')
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
    return evt
  }

  if (typeof window.CustomEvent !== 'function') {
    CustomEvent.prototype = window.Event.prototype
    window.CustomEvent = CustomEvent
  }

  if (!Element.prototype.matches) {
    Element.prototype.matches =
      // @ts-ignore
      Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector
  }

  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var el = this

      do {
        if (el.matches(s)) return el
        el = el.parentElement || el.parentNode
      } while (el !== null && el.nodeType === 1)
      return null
    }
  }
}

const el = document.querySelector(`dh-valg-resultat`)
const staticHost = el && el.getAttribute('data-static-host')

if (staticHost) {
  fixPublicPath(staticHost)
}

/**
 * Loads the customElements used in the page when the browser is idle
 *
 * The polyfill is loaded on demand here because Edge is defined as a modern browser
 *  as it supports type="module" scripts, but does not support customElements.
 * The polyfill MUST be loaded before the actual custom elements are loaded.
 */
requestIdleCallbackShim(async () => {
  if (!('customElements' in window)) {
    await import(
      '@webcomponents/custom-elements' /* webpackChunkName: "@webcomponents-custom-elements" */
    )
  }

  await import('./custom-elements' /* webpackChunkName: "custom-elements" */).then(module =>
    module.default()
  )

  if (typeof customElements.get('dh-valg-resultat') === 'undefined') {
    customElements.define('dh-valg-resultat', require('./client').ValgResultatApp)
  }
})
